import { financeRoutes, financeNavigationItems } from "./router";
/**
 * Finance Module
 * Handles Donations and Subscriptions workflows.
 */
export class FinanceModule {
    constructor() {
        Object.defineProperty(this, "contracts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    register(contracts) {
        this.contracts = contracts;
        contracts.logger.debug("[FinanceModule] Registered");
        return {
            id: "finance",
            name: "Finance Module",
            version: "1.0.0",
        };
    }
    getRoutes() {
        return financeRoutes;
    }
    getNavigationItems() {
        return financeNavigationItems;
    }
    getComponent() {
        return null;
    }
    unregister() {
        this.contracts?.logger.debug("[FinanceModule] Unregistered");
        this.contracts = null;
    }
}
export default new FinanceModule();
